//CRN_20260724 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable, of } from 'rxjs';
import { TypeSupportPlanDTO } from 'src/app/core/models/system/type/type-support-plan.dto';

@Injectable({ providedIn: 'root' })

export class TypesSupportPlanService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getAll(): Observable<TypeSupportPlanDTO[]> {
    try {
      return this.httpClientService.get<TypeSupportPlanDTO[]>(environment.eSimApi
                                                              + eSimApiPaths.TypesSupportPlan);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeSupportPlanDTO[]>(environment.eSimApi
                                                              + eSimApiPaths.TypesSupportPlan)
             .pipe(
                map(x => x.map(this.idAndDescriptionConverter))
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(typeSupportPlan: TypeSupportPlanDTO): IdAndDescriptionDTO {
    return { id: typeSupportPlan.id, description: typeSupportPlan.supportPlan };
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
